var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-zoom-control"
  }, [_c('div', {
    staticClass: "ugc-zoom-control-value",
    attrs: {
      "id": "zoomLabel"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.zoomPercentage.toFixed(0)) + "%\n  ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoomValue,
      expression: "zoomValue"
    }],
    ref: "zoomInput",
    staticClass: "ugc-zoom-control-input",
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "role": "slider",
      "aria-labelledby": "zoomLabel",
      "aria-valuemin": _vm.min,
      "aria-valuemax": _vm.max,
      "aria-valuenow": _vm.zoomValue
    },
    domProps: {
      "value": _vm.zoomValue
    },
    on: {
      "input": _vm.onChange,
      "__r": function __r($event) {
        _vm.zoomValue = $event.target.value;
      }
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }